import {
  FloatingSection,
  Header,
  Intro,
  NewsWidget,
} from "@prmf/site-components";
import { routes, t } from "@prmf/site-router";

const items = [
  [
    "/media/assets/corporate-responsibility-item-1.jpg",
    "Experience counts",
    <>
      <p>
        PRMF has over 70 years of experience supplying kitchens to the UK’s
        leading house builders, high-rise developers and social housing
        providers.
      </p>
      <p>
        We recognise that customers’ requirements vary and one size definitely
        does not fit all. Our flexible design and manufacturing process enables
        Paula Rosa Manhattan to deliver kitchens from entry-level through to
        bespoke, top-end solutions for high-value regeneration projects.
      </p>
    </>,
  ],
  [
    "/media/assets/corporate-responsibility-item-2.jpg",
    "Environmental care and sustainability",
    <>
      <p>
        To maintain our important role in caring for the environment, we use
        sensitively sourced products and continually look to improve our
        manufacturing processes. Sustainable delivery has also helped us to
        achieve a carbon-neutral factory since 2022.
      </p>
      <p>
        We source the majority of our materials in the UK and have been
        manufacturing on the same site from our factory facility and office
        based in Lancing, West Sussex since 1946. We have a strong team of
        long-serving, local, skilled and creative people.
      </p>
    </>,
  ],
  [
    "/media/assets/corporate-responsibility-item-3.jpg",
    "Strength through our group",
    <>
      <p>
        Paula Rosa Manhattan is a member of the Ballingslöv International Group,
        a major kitchen and furniture manufacturer in Europe.{" "}
      </p>
      <p>
        The parent company is Stena, one of Sweden’s largest, privately owned
        family businesses.  This gives our company access to an unrivalled
        wealth of procurement and sourcing opportunities through large
        multi-national suppliers with UK outlets, as well as access to kitchen
        industry experience and future trends.
      </p>
    </>,
  ],
  [
    "/media/assets/corporate-responsibility-item-4.jpg",
    "World-class manufacturing",
    <p>
      Our state-of-the-art manufacturing facility gives our customers more
      choice, reliable delivery times and guaranteed quality. Our cabinets have
      a comprehensive guarantee as well as Blum’s Lifetime Guarantee on their
      hinges and drawers.
    </p>,
  ],
  [
    "/media/assets/corporate-responsibility-item-5.jpg",
    "Reliable delivery times",
    <p>
      Our standard lead time from call-off is 4 weeks, with the opportunity for
      quicker priority delivery for small orders. We review our performance
      daily across a range of critical measures, one being On Time In Full
      (OTIF), and achieve exceptional results, giving you the reassurance that
      your kitchen will arrive as planned.
    </p>,
  ],
  [
    "/media/assets/corporate-responsibility-item-6.jpg",
    "Industry-leading customer service",
    <p>
      We aim for our service levels and customer care to be unrivalled in the
      industry. Through the continual development of our product range, the
      reliability of our delivery and the extensive availability of after-sales,
      our team’s focus is to provide you with excellence in service and
      response.
    </p>,
  ],
  [
    "/media/assets/corporate-responsibility-item-7.jpg",
    "Innovative product and creative design services",
    <>
      <p>
        All our units are certified with the FIRA Gold Award for Design and
        Manufacture and are fully assembled for ease of installation. Our 16mm
        cabinet provides sustainability benefits related to reduced timber use
        and weight saving, and passes all the same testing standards (Heavy
        Domestic/Contract standard [BS EN 6222 Level H]) applied to the
        conventional 18mm cabinet. With a proven durability and excellent
        guarantee, it’s a win-win for you.
      </p>
      <p>
        Our design team, based in all of our offices, work with you and can
        provide bespoke kitchen solutions to meet your requirements. 
      </p>
    </>,
  ],
  [
    "/media/assets/corporate-responsibility-item-8.jpg",
    "Industry-leading installation service",
    <p>
      We offer one of the longest serving and experienced installation teams
      supported by our national team of contract and project managers. Paula
      Rosa Manhattan is the first company to have been awarded FIRA Gold
      Installation Certification.
    </p>,
  ],
];

export default function Responsibility() {
  return (
    <div>
      <Header
        title="Committed to Excellence"
        image={t(routes.corporateResponsibility, "image")}
      >
        <p>
          Our mission and values ensure that we all work to provide excellent
          customer service. Whether sales and design, product manufacture,
          installation or aftercare, members of our team really care about the
          quality of product and service you receive each step of the way.
          Things don’t always go to plan, but you can be certain that we will
          work together to respond decisively to protect our track record of
          customer excellence.{" "}
        </p>
        <p>
          For decades, Paula Rosa Manhattan has built its reputation for
           high-quality kitchens and our products have proved the test of  time,
          with many of our customers repeatedly returning for their  next
          projects.{" "}
        </p>
      </Header>
      <Intro title="Why choose PRMF for your project?">
        <div className="max-w-lg space-y-4">
          <p>
            We strive to provide environmentally sustainable products and ways
            of working that lead the market in many pertinent areas. Sourcing is
            UK focused for our factory in Lancing, West Sussex.
          </p>
          <p>
            Our all-encompassing service and extensive product range, combined
            with our market-leading installation services, makes Paula Rosa
            Manhattan an ideal partner.
          </p>
        </div>
      </Intro>
      <div className="space-y-10">
        {items.map(([img, title, children], i) => (
          <FloatingSection
            reverse={!(i % 2)}
            bgColor="white"
            image={img}
            className="min-h-[300px]"
            title={
              <>
                <h3 className="font-semibold">{title}</h3>
                {children}
              </>
            }
          />
        ))}
      </div>
      <NewsWidget />
    </div>
  );
}
